export default {
  meta: {
    title: '行业商圈',
    // url: '/recommend/map',
  },
};
